<div class="form-title upper-space">
  <div class="form-title-text">Ontwerp</div>
</div>

<mat-radio-group
  formControlName="position"
  aria-label="Select an option"
  class="upper-space d-flex"
>
  <mat-radio-button
    class="left-space"
    value="upload"
    (change)="positionChange($event)"
    >Bestanden uploaden</mat-radio-button
  >

  <mat-radio-button
    class="left-space"
    value="known"
    (change)="positionChange($event)"
    >Inpress kent het ontwerp</mat-radio-button
  >

  <mat-radio-button
    class="left-space"
    value="sameAs"
    (change)="positionChange($event)"
    >Zelfde ontwerp als</mat-radio-button
  >
</mat-radio-group>

<mat-form-field class="form-field upper-space" appearance="outline">
  <mat-select
    matInput
    placeholder="kies een voorgaand project"
    formControlName="project"
    required
    (selectionChange)="projectChosen($event)"
  >
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option }}
    </mat-option>
  </mat-select>
</mat-form-field>
